export enum AliasErrorCode {
  ERROR_ON_UPDATING_ALIAS = 'IGABFF11',
  ALIAS_ALREADY_ASSIGNED_TO_CVU = 'IGABFF12',
  ALIAS_UNAVAILABLE = 'IGABFF13',
  ALIAS_CHANGED_IN_LAST_24_HOURS = 'IGABFF14',
  ACCOUNT_CVU_NOT_FOUND = 'IGABFF15',
}

type ErrorContent = {
  title: string
  description: string
}

type ErrorContentMap = Record<string, Record<AliasErrorCode, ErrorContent>>

export const errorContentMap: ErrorContentMap = {
  'pt-BR': {
    [AliasErrorCode.ERROR_ON_UPDATING_ALIAS]: {
      title: 'Erro ao atualizar o alias',
      description: 'Não conseguimos atualizar seu alias. Por favor, tente novamente mais tarde.',
    },
    [AliasErrorCode.ALIAS_ALREADY_ASSIGNED_TO_CVU]: {
      title: 'Alias já atribuído',
      description: 'Este alias já está associado à sua conta.',
    },
    [AliasErrorCode.ALIAS_UNAVAILABLE]: {
      title: 'Alias indisponível',
      description: 'O Alias informado já está em uso. Escolha outro identificador.',
    },
    [AliasErrorCode.ALIAS_CHANGED_IN_LAST_24_HOURS]: {
      title: 'Edição indisponível',
      description:
        'Você já editou o Alias nas últimas 24 horas.\nAguarde por um dia antes de tentar de novo.',
    },
    [AliasErrorCode.ACCOUNT_CVU_NOT_FOUND]: {
      title: 'Conta não encontrada',
      description: 'Não encontramos a conta associada. Por favor, tente novamente mais tarde.',
    },
  },
  'en-US': {
    [AliasErrorCode.ERROR_ON_UPDATING_ALIAS]: {
      title: 'Error updating alias',
      description: "We couldn't update your alias. Please try again later.",
    },
    [AliasErrorCode.ALIAS_ALREADY_ASSIGNED_TO_CVU]: {
      title: 'Alias already assigned',
      description: 'This alias is already assigned to your account.',
    },
    [AliasErrorCode.ALIAS_UNAVAILABLE]: {
      title: 'Alias Unavailable',
      description:
        'You have edited the Alias in the last 24 hours.\nPlease wait a day before trying again.',
    },
    [AliasErrorCode.ALIAS_CHANGED_IN_LAST_24_HOURS]: {
      title: 'Edit Unavailable',
      description:
        'You have edited the Alias in the last 24 hours.\nPlease wait a day before trying again.',
    },
    [AliasErrorCode.ACCOUNT_CVU_NOT_FOUND]: {
      title: 'Account not found',
      description: "We couldn't find the associated account. Please try again later.",
    },
  },
  'es-ES': {
    [AliasErrorCode.ERROR_ON_UPDATING_ALIAS]: {
      title: 'Error al actualizar el alias',
      description: 'No pudimos actualizar tu alias. Por favor, intentá de nuevo más tarde.',
    },
    [AliasErrorCode.ALIAS_ALREADY_ASSIGNED_TO_CVU]: {
      title: 'Alias ya asignado',
      description: 'Este alias ya está asignado a tu cuenta.',
    },
    [AliasErrorCode.ALIAS_UNAVAILABLE]: {
      title: 'Alias no disponible',
      description: 'El Alias ingresado ya está en uso. Elegí otro.',
    },
    [AliasErrorCode.ALIAS_CHANGED_IN_LAST_24_HOURS]: {
      title: 'Edición no disponible',
      description:
        'Has editado el Alias en las últimas 24 horas.\nEspera un día antes de intentar de nuevo.',
    },
    [AliasErrorCode.ACCOUNT_CVU_NOT_FOUND]: {
      title: 'Cuenta no encontrada',
      description: 'No encontramos la cuenta asociada. Por favor, intentá de nuevo más tarde.',
    },
  },
}

export const buttonLabel: Record<string, string> = {
  'pt-BR': 'Entendi',
  'en-US': 'Got it',
  'es-ES': 'Entendido',
}
